import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
@Injectable({
   providedIn : 'root'
})
export class CartService{
     checkOutCartData : any = [];

     constructor(private http : HttpClient ){}
     
    sendData(resData : any){
      let data = resData;
      this.http.post("https://e-commerce-page-test-default-rtdb.firebaseio.com/checkOutData.json",data).subscribe( Data =>{
         console.log(Data);
      });
   }

}